import type { BaseBlock } from "@/react/components/shared/BuilderUI/DataModel.types";

import { defaultStyles } from "./defaultStyles";

export const defaultData: BaseBlock = {
  id: "form-button-block",
  type: "FormButtonBlock",
  props: {
    label: {
      prop: "other",
      type: "string",
      value: "Submit",
    },
    styles: {
      prop: "styles",
      type: "styles",
      value: {
        margin: {
          type: "margin",
          value: defaultStyles.margin,
        },
      },
    },
  },
};
